import { Link } from "react-scroll";
import { useTranslation } from "react-i18next";
import { BoldText, CruiseSubHeader, CruiseWrapper, Description, ListItem, ListTitle, SocialLink, StyledList, } from "../styled";
import { StaggeredContainer, StaggeredItem } from "../../animations/staggeredFadeIn";
import { LINKS } from "../../../config/links";

const Cruises = () => {
    const { t } = useTranslation("cruises");

    const castlesItems = t("sections.castles.items", { returnObjects: true });
    const roundItems = t("sections.round.items", { returnObjects: true });
    const hoursItems = t("sections.hours.items", { returnObjects: true });
    const extraItems = t("sections.extra.items", { returnObjects: true });
    const marinaItems = t("sections.marina.items", { returnObjects: true });
    console.log("castlesItems:", castlesItems, typeof castlesItems);
    const renderList = (items) => (
        <StyledList>
            {items.map((item, idx) => {
                if (item.type === "link") {
                    return (
                        <ListItem key={idx}>
                            <BoldText>{item.label} </BoldText>
                            {item.textBeforeLink}
                            <SocialLink
                                as={Link}
                                to="footer"
                                smooth
                                duration={1000}
                                offset={-90}
                            >
                                {item.linkText}
                            </SocialLink>
                            {item.textAfterLink}
                        </ListItem>
                    );
                }

                return (
                    <ListItem key={idx}>
                        <BoldText>{item.label} </BoldText>
                        {item.text}
                    </ListItem>
                );
            })}
        </StyledList>
    );

    return (
        <CruiseWrapper id={LINKS.sections.cruiseDescription}>
            <StaggeredContainer>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.routes.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <ListTitle>{t("sections.castles.title")}</ListTitle>
                </StaggeredItem>
                <StaggeredItem>{renderList(castlesItems)}</StaggeredItem>
                <StaggeredItem>
                    <ListTitle>{t("sections.round.title")}</ListTitle>
                </StaggeredItem>
                <StaggeredItem>{renderList(roundItems)}</StaggeredItem>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.hours.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <Description>{t("sections.hours.intro")}</Description>
                </StaggeredItem>
                <StaggeredItem>{renderList(hoursItems)}</StaggeredItem>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.extra.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>{renderList(extraItems)}</StaggeredItem>
                <StaggeredItem>
                    <CruiseSubHeader>{t("sections.marina.title")}</CruiseSubHeader>
                </StaggeredItem>
                <StaggeredItem>
                    <Description>{t("sections.marina.intro")}</Description>
                </StaggeredItem>
                <StaggeredItem>{renderList(marinaItems)}</StaggeredItem>
            </StaggeredContainer>
        </CruiseWrapper>
    );
};

export default Cruises;